<template>
  <div class="bg-card bg-white border-card-border md:px-6">
    <div class="w-full mt-10 mb-6">
      <div>
        <h1 slot="header" class="text-xl font-semibold pb-2">
          Congratulations! You are pre-approved!
        </h1>
        <h3 slot="header" class="pb-3 border-b mb-4"></h3>
      </div>
      <!-- <p class="text-gray-800 sm:pt-1 mb-6">
        Please authorize VIVA Finance Inc. to pull your credit and bankruptcy information.
        <span class="text-gray-800 font-bold"
          >Your credit history does not affect your ability to take out a loan with VIVA
          Finance*.</span
        >
      </p> -->
      <div class="py-4">
        <div class="mb-6">
          <div class="flex-col leading-none">
            <p class="text-xs leading-7 mb-4">
              Based on the information you provided, you may be eligible for the below loan option
              with VIVA Finance.
            </p>
            <p class="text-xs leading-7">
              If you choose to start an application, you understand that your final loan offer may
              change following the verification of your reported information, payroll compatability,
              bankruptcy history, and credit history.
            </p>
          </div>
        </div>

        <div class="mb-10">
          <div class="flex justify-center">
            <div class="flex justify-center w-800">
              <div class="grid grid-col-1 items-center border m-3 p-3 gap-2 w-400">
                <span class="viva-green-text text-lg text-center mb-6"><b>Loan Details</b></span>
                <div class="text-center">
                  <div class="flex justify-center">
                    <p class="text-black mr-2">
                      <b>Loan Amount:</b>
                    </p>
                    <p>{{ preQualifiedAmount }}</p>
                  </div>
                </div>
                <div class="text-center">
                  <div class="flex justify-center">
                    <p class="text-black mr-2">
                      <b>Simple Interest Rate:</b>
                    </p>
                    <p>{{ preQualifiedInterestRate }}%</p>
                  </div>
                </div>
                <div class="text-center">
                  <div class="flex justify-center">
                    <p class="text-black mr-2">
                      <b>Fee:</b>
                    </p>
                    <p>{{ preQualifiedOriginationFee }}</p>
                  </div>
                </div>
                <div class="text-center">
                  <div class="flex justify-center mb-6">
                    <p class="text-black mr-2">
                      <b>Term:</b>
                    </p>
                    <p>{{ preQualifiedTerm }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="flex justify-center items-center">
          <div class="flex justify-center w-full mt-4">
            <!-- <button
            class="hover:text-primary mr-auto focus:outline-none rounded"
            type="btn"
            aria-label="navigate back"
            v-on:click="$emit('back')"
          >
            <i
              class="fas fa-arrow-left bg-gray-300 rounded-full flex items-center text-lg justify-center w-8 h-8"
            ></i>
          </button> -->

            <base-button
              :class="` ${button ? 'opacity-50' : ''}`"
              type="primary items-center"
              :disabled="button"
              aria-label="navigate next"
              id="prequal-approve-start-app-button"
              @click="handleNext()"
            >
              Start My Application
            </base-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrequalApprove',
  data: function () {
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })
    return {
      butt: true,
      preQualifiedAmount: formatter.format(this.$store.getters.preQualifiedAmount),
      preQualifiedInterestRate: this.$store.getters.preQualifiedInterestRate,
      preQualifiedTerm: this.$store.getters.preQualifiedTerm,
      preQualifiedOriginationFee: formatter.format(this.$store.getters.preQualifiedOriginationFee)
    }
  },
  computed: {},
  mounted() {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  },
  methods: {
    handleNext() {
      // window.scrollTo({ top: 0, behavior: 'smooth' })
      this.$emit('next')
    }
    // handleBack() {
    //   // window.scrollTo({ top: 0, behavior: 'smooth' })
    //   this.$emit('back')
    // }
  }
}
</script>

<style scoped></style>
